var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-table',{attrs:{"rowKey":"id","columns":_vm.columns,"data-source":_vm.items,"size":"small","pagination":_vm.pagination,"loading":_vm.loading},on:{"change":_vm.tableChange},scopedSlots:_vm._u([{key:"avg_retail_price",fn:function(value){return _c('div',{},[_vm._v(_vm._s(_vm.NP.round(value, 2)))])}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }